<template>
    <div class='info'>
        <template v-for="(item,index) in dataList">
            <div :class="{'info-cell':true,'info-color':index%2 ===0}">
                <ElRow class="info-warp">
                    <ElCol :xs="{span:24}" :sm="12" :md="12" :lg="12" :xl="12">
                        <template v-if="index%2 ===0">
                            <div class="info-content info-left">
                                <p class="title">{{item.title}}</p>
                                <div class="content" v-html="item.content"></div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="info-content info-right"><img :src="item.pic" alt=""></div>
                        </template>
                    </ElCol>
                    <ElCol :xs="{span:24}" :sm="12" :md="12" :lg="12" :xl="12">
                        <template v-if="index%2 !==0">
                            <div class="info-content info-left">
                                <p class="title">{{item.title}}</p>
                                <div class="content" v-html="item.content"></div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="info-content info-right"><img :src="item.pic" alt=""></div>
                        </template>
                    </ElCol>
                </ElRow>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "item",
        props: {
            dataList: {
                type: Array,
                default: () => {
                    return []
                }
            }
        }
    }
</script>

<style lang='less' scoped>
    @import "../../../style/constant.less";

    .info {
        margin: 0 auto;
        .info-color {
            background-color: #fafafa;

        }
        .info-cell {
            width: 100%;
            padding: 50px 0 100px 0;

            .el-row {
                margin: 0 auto !important;
            }

            .info-warp {
                max-width: @page-width;

                .info-content {
                    padding: 15px;
                    .title {
                        font-size: 32px;
                        font-family: Poppins, sans-serif;
                        font-weight: 500;
                        margin: 30px 0;
                    }
                    @media screen and (min-width: 320px) and (max-width: 480px) {
                        .title{
                            font-size: 26px;
                        }
                    }

                    .content {
                        white-space: pre-line;
                        line-height: 30px;
                        color: @content-color;
                        font-size: 15px;
                    }
                }

                .info-left {
                    box-sizing: border-box;
                    width: 100%;

                }

                .info-right {
                    margin-top: 45px;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                @media screen and (min-width: 320px) and (max-width: 480px) {
                    .info-right{
                        margin-top: 10px;
                    }
                }
            }
        }
        @media screen and (min-width: 320px) and (max-width: 480px) {
             .info-cell{
                padding-bottom: 10px;
            }
        }
    }

</style>